module.exports = __webpack_public_path__ + "static/img/collectedImg.261e59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collectedImg.png
// module id = VQg+
// module chunks = 52